import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, of } from "rxjs";
import { map, pluck } from "rxjs/operators";
import { EmpUserService } from "./emp-user.service";
import { WisConfigService } from "./wis-config.service";

@Injectable({
  providedIn: "root"
})
export class TeamCalendarService {
  url: Observable<string>;
  constructor(private wisCfgSvc: WisConfigService, private userSvc: EmpUserService) {}

  consturctUrl() {
    return this.wisCfgSvc.serviceHosts.pipe(
      pluck("empExpUi"),
      map(url => `${url}/#/team-calendar?buid=${this.userSvc.employeeInfo.buid}&empGuid=${this.userSvc.employeeInfo.empGuid}`)
    );
  }

  refreshFrame() {
    // this.url = of("");
    this.url = this.consturctUrl();
  }
}
